'use client';

import Link from 'next/link';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import React from 'react';
import Button from '../../elements/Button';
import styles from './index.module.scss';

const Navigation = ({ entry, company }: { entry?: any; company?: any }) => {
  const pathname = usePathname();
  const params = useParams();
  const searchParams = useSearchParams();
  const mode = searchParams.get('mode') ?? 'mobile';
  return (
    <>
      <header
        className={`${styles.navigation} ${
          company?.whitelabel ? styles.whitelabel : null
        }`}
        style={
          {
            '--color': company?.whitelabel
              ? (entry.brand?.color ?? null)
              : null,
          } as React.CSSProperties
        }
      >
        <nav className={styles.switch}>
          <ul className={styles.list}>
            <li>
              <Link
                href={{
                  pathname: pathname,
                  query: {
                    ...Object.fromEntries(searchParams),
                    mode: 'mobile',
                  },
                }}
                className={mode === 'mobile' ? styles.active : undefined}
              >
                Mobile
              </Link>
            </li>
            <li>
              <Link
                href={{
                  pathname: pathname,
                  query: {
                    ...Object.fromEntries(searchParams),
                    mode: 'desktop',
                  },
                }}
                className={mode === 'desktop' ? styles.active : undefined}
              >
                Desktop
              </Link>
            </li>
          </ul>
        </nav>
        <nav className={styles.content}>
          <div>
            <span className={styles.name}>Preview</span>
          </div>

          {!company?.whitelabel && (
            <ul className={styles.list}>
              <li>
                <Button href="https://www.coverstories.co" link arrow>
                  Discover Coverstories
                </Button>
              </li>
            </ul>
          )}
          {company?.whitelabel_url && (
            <ul className={styles.list}>
              <li>
                <Button
                  href={entry.brand.website ?? company?.whitelabel_url ?? '#'}
                  link
                >
                  {entry.brand.name ?? company?.name ?? ''}
                </Button>
              </li>
            </ul>
          )}
        </nav>
      </header>
    </>
  );
};

export default Navigation;
